export default {
  title: 'Seguir tu pedido',
  text: '¡Gracias por pedir aquí! Nuestra colaboración con <0>{{carrier}}</0> nos permite gestionar las entregas directamente en nuestro sitio, ahorrando de media {{savings}} en comisiones de entrega. Tu pedido será entregado por <1>{{carrier}}</1>, garantizando un excelente servicio 😊',
  labels: {
    delivered_by: 'Entregado por',
  },
  buttons: {
    track_order: 'Seguimiento en tiempo real →',
    track_order_once_confirmed: 'Seguimiento en tiempo real una vez confirmado',
  },
};
